import SolutionTemplate from '@LandingFunctionalDisplay/SolutionTemplate';
import { hrOperationsData } from '@LandingFunctionalDisplay/SolutionTemplate/solutionData';

export default function HROperationsPage() {
    return <SolutionTemplate {...hrOperationsData} />;
}
